/* Version: 3.5.149 */
'use client';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

function makeMenuItems(items, placeholder) {
  var native = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (placeholder !== '') {
    return [{
      value: native ? '' : null,
      label: placeholder,
      disabled: true
    }].concat(_toConsumableArray(items));
  }
  return items;
}
function getDisabledKeys(items) {
  return items.filter(function (item) {
    return item.disabled === true;
  }).map(function (item) {
    return item.value;
  });
}
function getSelectedIndex(items, value) {
  var selected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (value !== null) {
    return items.findIndex(function (x) {
      return x.value === value && !x.disabled;
    });
  }
  return selected;
}
function getSelectedItemDetails(items, selected) {
  return {
    value: items[selected] && items[selected].value,
    label: items[selected] && items[selected].label,
    isDisabled: items[selected] ? items[selected].disabled : false
  };
}

export { getDisabledKeys, getSelectedIndex, getSelectedItemDetails, makeMenuItems };
